import el from "@cypherpotato/el";
import { throttledCall } from "../ui/throttle";
import { FormControl, TextInput } from "./form";

export function Image(src, ...args) {
    return el("img", { src }, ...args);
}

export function ImageContainer(src, boxSize, ...args) {

    const srcState = el.state.create(src);

    return el.state.listening([srcState], () =>
        el("div.image-container",
            Image(srcState.value ?? "", {
                style: {
                    width: (boxSize + 10) + "px",
                    height: (boxSize + 10) + "px"
                },
                onError(event) {
                    event.target.closest(".image-container").classList.add("image-error");
                },
                onLoad(event) {
                    event.target.closest(".image-container").classList.remove("image-error");
                }
            }),
            el(".image-error-message",
                srcState.value?.nullWhenEmpty() == null ? "No image was provided" : "Image could not be loaded"
            ),
            {
                $properties: {
                    src: {
                        get() {
                            return srcState.value;
                        },
                        set(value) {
                            srcState.value = value;
                        }
                    }
                }
            },
            ...args
        )
    );
}

export function ImageControl({ value, props }) {

    const srcState = el.state.create(value);

    return el(".image-control-wrapper",
        el.state.listening([srcState], () =>
            ImageContainer(srcState.value, 120)
        ),
        FormControl("Image source URL",
            TextInput(null, "https://", {
                onInput(event) {
                    throttledCall(() => {
                        srcState.value = event.target.value;
                    }, 300);
                },
                value: srcState.value
            })
        ),
        {
            $properties: {
                value: {
                    get() {
                        return srcState.value;
                    },
                    set(value) {
                        srcState.value = value;
                    }
                }
            }
        },
        props
    );
}
